import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../img/logo.png';

function SubpageTopBar() {
  return (
    <header className="subpage-top">
      <div className="container d-flex align-items-center py-3">
        <Link to="/" className="navbar-brand m-0">
          <img className="logo" src={logo} alt="East IT" />
        </Link>
        <Link to="/" className="ms-auto text-white text-decoration-none fs-4">
          east-it.sk
        </Link>
      </div>
    </header>
  );
}

export default SubpageTopBar;
